import React from 'react';
import PropTypes from 'prop-types';
import LocalizationConsumer from '../../../../l10n/localization-context';

const ImagePreview = ({ previewImage }) =>
{
  if (!previewImage) return null;

  return (
    <div className="-wa-edit-controls__property-container">
      <div className="-wa-edit-controls__property-label -wa-edit-controls__property-label-image">
        <LocalizationConsumer id="insert-link-dialog.image-preview-label" />
      </div>
      <div className="-wa-edit-controls__property-control">
        <img
          className="-wa-edit-controls__image-preview"
          src={previewImage}
          alt={<LocalizationConsumer id="insert-link-dialog.settings.preview-image-alt" />}
        />
      </div>
    </div>
  );
};

ImagePreview.propTypes = {
  previewImage: PropTypes.string.isRequired
};

export default ImagePreview;